import { render, staticRenderFns } from "./PedidosValidarSingle.vue?vue&type=template&id=96e4ef48&scoped=true&lang=pug"
import script from "./PedidosValidarSingle.vue?vue&type=script&lang=js"
export * from "./PedidosValidarSingle.vue?vue&type=script&lang=js"
import style0 from "./PedidosValidarSingle.vue?vue&type=style&index=0&id=96e4ef48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e4ef48",
  null
  
)

export default component.exports